export default function ListIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill='none'
    >
      <g clipPath='url(#clip0_513_1769)'>
        <path
          d='M13.3337 2H4.00033C3.26699 2 2.66699 2.6 2.66699 3.33333V12.6667C2.66699 13.4 3.26699 14 4.00033 14H13.3337C14.067 14 14.667 13.4 14.667 12.6667V3.33333C14.667 2.6 14.067 2 13.3337 2ZM6.66699 11.3333H5.33366V6.66667H6.66699V11.3333ZM9.33366 11.3333H8.00033V4.66667H9.33366V11.3333ZM12.0003 11.3333H10.667V8.66667H12.0003V11.3333Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_513_1769'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0.666992)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}